var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2759_3703",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2759_3703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 10.9682V2.4952C1.3335 2.30765 1.39898 2.15044 1.52995 2.02357C1.66092 1.89669 1.82322 1.83325 2.01683 1.83325H10.6668C10.8446 1.83325 11.0002 1.89714 11.1335 2.02492C11.2668 2.1527 11.3335 2.31103 11.3335 2.49992V8.49992C11.3335 8.6777 11.2668 8.83325 11.1335 8.96659C11.0002 9.09992 10.8446 9.16659 10.6668 9.16659H4.05016L1.95016 11.2166C1.82794 11.3388 1.69461 11.3666 1.55016 11.2999C1.40572 11.2333 1.3335 11.1227 1.3335 10.9682ZM4.71683 12.4999C4.53905 12.4999 4.3835 12.4333 4.25016 12.2999C4.11683 12.1666 4.05016 12.0103 4.05016 11.8312V10.5666H12.7335V4.51659H13.9835C14.1771 4.51659 14.3394 4.58207 14.4704 4.71304C14.6013 4.84401 14.6668 5.00631 14.6668 5.19992V14.2833C14.6668 14.4518 14.5918 14.5661 14.4418 14.6263C14.2918 14.6865 14.1557 14.6555 14.0335 14.5333L12.0002 12.4999H4.71683ZM9.9335 3.23325H2.7335V7.76659H9.9335V3.23325Z",
    fill: "url(#paint0_linear_2759_3703)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2759_3703",
    x1: 15.9496,
    y1: 13.1868,
    x2: 2.73202,
    y2: 15.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7030A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#D96380"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF934E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.5e057c16751c35a79968c18a73a60b9b.svg";
export { ForwardRef as ReactComponent };